import { Component, OnInit } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { AlertComponent } from 'app/popup/alert.component';
import { ErrorComponent } from 'app/popup/error.component';
import { VehicleTypeService } from 'app/services/vehicle-type.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-list-vehicle-type',
  templateUrl: './list-vehicle-type.component.html',
  styleUrls: ['./list-vehicle-type.component.css']
})
export class ListVehicleTypeComponent implements OnInit {

  vTypes: any = [];
  isRemove = false;
  removeRef: any;
  criteria = 'code';
  direction = false;  
  lblHeading = '';

  popoverTitle = 'Delete Vehicle Type';
  popoverMessage = 'Are you sure you want to delete Vehicle Type?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  message = "Loading Vehicle Type...";

  public isLoading = false;
  isEmpty: boolean = false;
  showNum: number = 10;

  constructor(private service: VehicleTypeService,private utility: UtilityServiceService,private toastr:ToastrService) { }

  ngOnInit() {
    this.onChangeHeandig();
    this.reload();
    this.utility.page = 1;
  }

  reload() {
    this.isLoading = true;
    this.service.getAll().subscribe(result => {
      this.vTypes = result;
      this.utility.onSort(1);     
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      this.isEmpty = true;
    });
  }

  onDelete(id: any) {
    this.service.delete(id).subscribe(result => {

      // this.dialogService.addDialog(AlertComponent, { title: 'Delete Vehicle Type', message: `Vehicle Type ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
      this.toastr.success(`Vehicle Type ${this.removeRef.code} deleted.`,'Delete Vehicle Type');
      if (result != null) {
        this.onNo();
        this.reload();
      }
      this.onChangeHeandig();
    }, error => {
      error = error.json();
      // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Vehicle Type', message: `Vehicle Type ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      this.toastr.error(`Vehicle Type ${this.removeRef.code} was not deleted.`,'Delete Vehicle Type');

    });
  }

  onSort() {
    this.direction = !this.direction;
  }

  onConfirm(doc: any) {
    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Vehicle Type <strong>${this.removeRef.code}</strong>?`;        
    this.onChangeHeandig(false);
    this.isRemove = true;
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeandig();
  }

  onChangeHeandig(change: boolean = true) {
    this.lblHeading = (change) ? 'Vehicle Types' : 'Delete Vehicle Type';    
  }


}
